import script from "./AppManageSecurity.vue?vue&type=script&setup=true&lang=js"
export * from "./AppManageSecurity.vue?vue&type=script&setup=true&lang=js"

import "./AppManageSecurity.vue?vue&type=style&index=0&id=43c59ef7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c59ef7"]])

export default __exports__